import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { Order } from '../../models';
import { BaseOnDestroyComponent } from '../../../shared/injectables/BaseOnDestroy.component';

@Component({
  selector: 'app-open-datarecovery-list-widget',
  styleUrls: ['./open-datarecovery-list-widget.component.scss'],
  template: `
    <div class="wrapper  p-y--8">
      <div class="widget card">
        <div class="widget_header ps-1">
          <span
            ><button mat-icon-button (click)="loadData()">
              <mat-icon>autorenew</mat-icon></button
            >Aktuell offene Datenrettungen</span
          >
        </div>
        <app-orders-list-for-widget
          [indicatorStyleFn]="getCircleColor"
          [states]="states"
        ></app-orders-list-for-widget>
      </div>
    </div>
  `
})
export class OpenDatarecoveryListWidgetComponent extends BaseOnDestroyComponent
  implements OnInit, OnDestroy {
  states: string[];

  constructor(private store$: Store<ApplicationState>) {
    super();
  }

  ngOnInit(): void {
    this.states = [
      'waiting_for_data_recovery_dr_de',
      'data_recovery_delayed_dr_de',
      'data_recovery_in_progress_dr_de', // aktuell in Datenrettung
      'data_recovery_completed_dr_de',
      'provide_data_recovery_result_dr_de'
    ];
  }

  loadData(): void {
    this.states = [...this.states];
  }

  getCircleColor(order: Order): { [key: string]: string } {
    return { backgroundColor: '#ffc400' };
  }
}
